import { Component, OnInit } from '@angular/core';
import { IItineraryHistory } from 'src/app/core/models/itinerary-history.model';
import { StepResult } from 'src/app/core/models/Step-Result.model';
import { OperationLogService } from '../../services/operation-log.service';
import { dictionary } from './pnr-dictionary';

@Component({
  selector: 'app-pnr-history',
  templateUrl: './pnr-history.component.html',
  styleUrls: ['./pnr-history.component.scss']
})
export class PnrHistoryComponent implements OnInit {
  history: string;
  classicHistory: string;
  itineraryHistory: StepResult[];
  finalItineraryHistory: StepResult[];
  excludeComands = ['MD', '*P3'];
  itineraryHistoryCopy: IItineraryHistory = {
    message: '',
    historicalInfo: []
  };

  isClassicReady = false;
  isSectionsReady = false;
  dictionary = dictionary;

  constructor(private service: OperationLogService) {}

  ngOnInit(): void {
    this.service.getPNRHistory().subscribe((res) => {
      this.history = res;
      this.isClassicReady = true;
      this.finalItineraryHistory = [];
      this.service.getPNRItineraryHistory().subscribe((res) => {
        if (res.length > 0) {
          this.itineraryHistory = res;
          this.isSectionsReady = true;
          this.formatClassicHistory(res);
          this.fillFinalItineraryHistory();
        }
      });
    });
  }

  formatClassicHistory(res: StepResult[]) {
    let finalString = '';
    const screenResultKey = 'screenResult';

    res.forEach((entrie) => {
      Object.entries(entrie).forEach(([key, value]) => {
        finalString += `${key}: ${value}${key == screenResultKey ? '' : '\n'}`;
      });

      finalString += '\n';
    });

    this.classicHistory = finalString;
  }

  fillFinalItineraryHistory() {
    this.itineraryHistory.forEach((x) => {
      if (!this.excludeComands.includes(x.screenCommand)) {
        x.name = this.dictionary.nameForHistory.find((name) => name.code === x.screenCommand)?.name;
        this.finalItineraryHistory.push(x);
      }
    });
  }

  toArray(object: object) {
    return Object.keys(object).map((key) => object[key]);
  }
}
